"use client"

import styled from 'styled-components';

export const WebContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`

export const Body = styled.div<{$isPadding: boolean}>`
    flex: 1;
    /* padding: ${props => props.$isPadding ? "200px 0px" : "0px"}; */
    
    @media (max-width: 768px) {
        padding: 0px;
    }
`